import * as yup from 'yup'
import { translate as t } from '../../../i18n'

export const athleteTrainingSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required(() => t('general.validator.empty')),
  sequence: yup
    .string()
    .default('2'),
  note: yup
    .string()
    .default('')
    .nullable()
})
